// extracted by mini-css-extract-plugin
module.exports = {"agendamento":"edicao-agendamento_agendamento__1kUQD"};